import React, { useState } from 'react';
import { usePageMeta } from '../../hooks/usePageMeta';
import { processPhases, processStages } from '../../data/process';
import { PageHero } from '../../components/ui/PageHero';
import { SectionHeading } from '../../components/ui/SectionHeading';
import { CtaBand } from '../../components/ui/CtaBand';
import { ProcessTimeline } from '../../components/process/ProcessTimeline';
export function Process() {
  usePageMeta('Our Search Process', 'The ten-stage Corventa search methodology, from discovery and briefing to appointment and post-placement follow-up.');
  const [phase, setPhase] = useState(0);
  const current = processPhases[phase];
  return <>
      <PageHero crumbs={[{
      label: 'Search Process'
    }]} kicker="Our search process" title="A methodology built for confident decisions." intro="Ten clearly defined stages, grouped into four phases, take every search from first conversation to a successful appointment." data-id="element-911" data-mp="3pnuvvebqsrgp" />

      <section className="bg-white py-24" data-id="element-912" data-mp="13xvc3xhz226b">
        <div className="container-page" data-id="element-913" data-mp="13ywygy4fub3c">
          <SectionHeading kicker="At a glance" title="Four phases, ten stages." intro="Select a phase to see the stages it contains." data-id="element-914" data-mp="yzk31ozi3vp5" />
          <div className="mt-12 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" role="tablist" aria-label="Process phases" data-id="element-915" data-mp="1d04jwfluvhg0">
            {processPhases.map((p, i) => <button key={p.name} type="button" role="tab" aria-selected={phase === i} aria-controls="phase-panel" onClick={() => setPhase(i)} className={`rounded-lg border p-5 text-left transition-[background-color,border-color] duration-150 ${phase === i ? 'border-midnight bg-midnight text-white' : 'border-line bg-white text-ink hover:border-midnight'}`} data-id="element-916" data-mp="1mwzj70pydlvc" data-mpi={i}>
                <span className={`font-display text-lg ${phase === i ? 'text-gold-300' : 'text-gold-700'}`} data-id="element-917" data-mp="20pfibqfqgzqz">Phase {i + 1}</span>
                <span className="mt-1 block font-display text-3xl font-semibold" data-id="element-918" data-mp="yct0ibtk2n3r">{p.name}</span>
                <span className={`mt-1 block text-sm ${phase === i ? 'text-white/70' : 'text-muted'}`} data-id="element-919" data-mp="12dcu55ex78l5">
                  Stages {p.stages[0] + 1}–{p.stages[p.stages.length - 1] + 1}
                </span>
              </button>)}
          </div>
          <div id="phase-panel" role="tabpanel" className="mt-8 rounded-xl bg-ivory p-6 md:p-8" data-id="element-920" data-mp="1h2908wxf2bj4">
            <p className="text-lg text-ink" data-id="element-921" data-mp="1m0aveg84a1ay">{current.text}</p>
            <div className="mt-6 flex flex-wrap gap-2" aria-label="All stages" data-id="element-922" data-mp="1m2x10abg66qj">
              {processStages.map((s, i) => {
              const inPhase = current.stages.includes(i);
              return <span key={s.title} className={`rounded-md border px-3 py-2 text-sm transition-[background-color,border-color,color,opacity] duration-200 ${inPhase ? 'border-gold bg-white text-ink' : 'border-transparent text-muted opacity-50'}`} data-id="element-923" data-mp="3rtsdyuk50v80" data-mpi={i}>
                    <span className="mr-1.5 font-display text-gold-700" data-id="element-924" data-mp="3khujgccdaz1b">{i + 1}</span>
                    {s.title}
                  </span>;
            })}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-ivory py-24" data-id="element-925" data-mp="3aidha4wbr3a3">
        <div className="container-page" data-id="element-926" data-mp="c32qv2k5i4je">
          <SectionHeading align="center" kicker="Stage by stage" title="How each stage works." className="mb-16" data-id="element-927" data-mp="c21bilw3qvvv" />
          <ProcessTimeline data-id="element-928" data-mp="71wvewz3w366" />
        </div>
      </section>

      <CtaBand title="Ready to begin?" text="A first conversation costs nothing and commits you to nothing." primary={{
      label: 'Begin a Confidential Search',
      to: '/executive-search#inquiry'
    }} secondary={{
      label: 'Contact us',
      to: '/contact'
    }} data-id="element-929" data-mp="23bsuqwdt7ek" />
    </>;
}